import { Loading, Table, TableContainer } from '@ui-components/neo.tax';
import React from 'react';
import { Column } from 'react-table';

interface TeamMemberTableData {
  allocationPercent: number;
  contributorName?: string | null;
}

interface TeamMembersTableProps<T extends TeamMemberTableData> {
  columns: Column<T>[] | null;
  endReached: () => Promise<void>;
  loadingRows: boolean;
  loadingFooter: boolean;
  teamMembers: T[] | null;
}

export const ProjectTeamMembersTable = <T extends TeamMemberTableData>({
  columns,
  endReached,
  loadingFooter,
  loadingRows,
  teamMembers,
}: TeamMembersTableProps<T>): React.ReactElement => {
  if (!teamMembers || !columns) {
    return <Loading height={160} />;
  }
  return (
    <TableContainer height="100%">
      <Table<T>
        columns={columns}
        data={teamMembers}
        endReached={endReached}
        loadMoreRowFromBottomThreshold={15}
        isFooterLoading={loadingFooter}
        isBodyLoading={loadingRows}
      />
    </TableContainer>
  );
};
